module.exports = __webpack_public_path__ + "img/favicon.a655c7fa.png";